import {toAbsoluteUrl} from 'helpers/AssetHelpers'
import SVG from 'react-inlinesvg'

const KTSVG = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export {KTSVG}
